import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'digital-quote-settings' */ './DigitalQuote'),
);
